// extracted by mini-css-extract-plugin
export default {"root":"EntityPickerActionButton_root__6MgDE"};